import React, { useState, useRef, useEffect } from "react";
import { Header } from "../Header/Header";
import loginbg from "../../img/loginbg.png";
import tenantname_example from "../../img/tenantname_example.png";
import { HiOutlineMail } from "react-icons/hi";
import { FaRegCircleUser } from "react-icons/fa6";
import { FaInfoCircle, FaTimes } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TbCloudUpload } from "react-icons/tb";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import LoadingButton from "../../HOC/LoadingButton";
import signupStyle from "./NewSignup.module.css";
import loginStyles from "../New Login/NewLogin.module.css";
import AlertPopup from "../../AlertPopup";
import ReCAPTCHA from "react-google-recaptcha";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
const isDevEnvironment = process.env.REACT_APP_STAGE_ENV === "dev";

console.log("here is a new onletsee", isDevEnvironment);

export const NewSignup = () => {
  const [captchaToken, setCaptchaToken] = useState(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const referedBy = params.get("refered_by");
  const companyId = params.get("company_id");
  const queryType = params.get("type");
  const queryEmail = params.get("email");
  const queryToken = params.get("token");

  // Support flow is only valid if a token is present in the URL
  const isSupportFlow = queryType === "support";
  const isSupportFlowWithoutToken = isSupportFlow && !queryToken;

  // Collect all metadata and UTM parameters
  const [metadata, setMetadata] = useState({});
  const [utmParams, setUtmParams] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState(null);
  const new_history = useHistory();
  const imageInput = useRef(null);
  const [showExamplePopup, setShowExamplePopup] = useState(false);

  // ─────────────────────────────────────────────────────────────
  // Signup questionnaire (2 questions)
  // Saved on the tenant as part of `meta_data` during /signup.
  // Later used to personalize Create App defaults + dashboard nudges.
  // ─────────────────────────────────────────────────────────────
  const [signupPrefs, setSignupPrefs] = useState({
    setup_mode: "",        // "solo" | "team"
    app_count_intent: "",  // "one" | "multiple"
  });

  // Which question's info panel is expanded (null = none)
  const [openInfoKey, setOpenInfoKey] = useState(null);
  const toggleInfo = (key) =>
    setOpenInfoKey((prev) => (prev === key ? null : key));

  const handleSignupPrefsChange = (key, value) => {
    setSignupPrefs((prev) => ({ ...prev, [key]: value }));
  };

  // Extract all metadata and UTM parameters on component mount
  useEffect(() => {
    const metadataObj = {};
    const utmObj = {};

    for (let [key, value] of params.entries()) {
      if (key.startsWith("metadata__")) {
        const metadataKey = key.substring(10);
        metadataObj[metadataKey] = value;
      } else if (key.startsWith("utm_")) {
        utmObj[key] = value;
      }
    }

    setMetadata(metadataObj);
    setUtmParams(utmObj);

    if (Object.keys(metadataObj).length > 0 || Object.keys(utmObj).length > 0) {
      console.log("Tracking parameters detected:", {
        metadata: metadataObj,
        utm: utmObj,
      });
    }
  }, [params]);

  // maintain separate data for each tab
  const [tenantData, setTenantData] = useState({
    tenant: "",
    email: "",
    password: "",
    full_name: "",
    phone: "",
    gender: "",
  });

  const [supportData, setSupportData] = useState({
    email: "",
    password: "",
    full_name: "",
    token: "",
  });

  const [tenantCountry, setTenantCountry] = useState(null);
  const [tenantTerms, setTenantTerms] = useState(false);
  const [supportTerms, setSupportTerms] = useState(false);

  // set default tab based on query param
  const [activeTab, setActiveTab] = useState(
    queryType === "support" ? "support_type" : "tenant_type"
  );

  const [showPassword, setShowPassword] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    type: "info",
    message: "",
  });

  // Prefill support data from query params (token + email — silent, not shown)
  useEffect(() => {
    if (queryType === "support") {
      setSupportData((prev) => ({
        ...prev,
        email: queryEmail || prev.email,
        token: queryToken || prev.token,
      }));
    }
  }, [queryType, queryEmail, queryToken]);

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
  };

  const handleTenantChange = (e) => {
    const { name, value } = e.target;
    setTenantData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSupportChange = (e) => {
    const { name, value } = e.target;
    setSupportData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTenantPhoneChange = (value) => {
    setTenantData((prev) => ({ ...prev, phone: value }));
  };

  const handleTenantTermsChange = (e) => setTenantTerms(e.target.checked);
  const handleSupportTermsChange = (e) => setSupportTerms(e.target.checked);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setFileName(file.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Skip CAPTCHA check in dev environment
    if (!isDevEnvironment && !captchaToken) {
      showAlert("error", "Please complete the CAPTCHA");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      const file = imageInput.current?.files?.[0];

      if (activeTab === "support_type") {
        const { email, password, full_name, token } = supportData;
        if (!token) {
          showAlert("error", "Token is required for Support Signup.");
          setIsLoading(false);
          return;
        }

        const supportFormData = new FormData();
        if (file) supportFormData.append("file", file, file.name);
        supportFormData.append("token", token);
        supportFormData.append("email", email);
        supportFormData.append("password", password);
        supportFormData.append("full_name", full_name);
        supportFormData.append("type", "support_type");

        if (!isDevEnvironment && captchaToken) {
          supportFormData.append("captcha_token", captchaToken);
        } else if (isDevEnvironment) {
          console.log("DEV Environment: Skipping CAPTCHA for support signup");
        }

        const response = await fetch(
          `https://auth2.${backend_api_base_url}/support_signup`,
          {
            method: "POST",
            headers: { Accept: "*/*" },
            body: supportFormData,
          }
        );

        const result = await response.json();

        let isError = false;
        let errorMessage = "Unknown error";

        if (!response.ok) {
          isError = true;
          if (result?.statusCode && result?.body) {
            try {
              const inner = JSON.parse(result.body);
              errorMessage =
                inner.error || inner.detail || inner.message || errorMessage;
            } catch (e) {
              errorMessage = result.body;
            }
          } else {
            errorMessage = result?.error || result?.detail || errorMessage;
          }
        } else if (result?.statusCode && Number(result.statusCode) !== 200) {
          isError = true;
          try {
            const inner =
              typeof result.body === "string"
                ? JSON.parse(result.body)
                : result.body;
            errorMessage =
              inner?.error || inner?.detail || inner?.message || errorMessage;
          } catch (e) {
            errorMessage =
              typeof result.body === "string" ? result.body : errorMessage;
          }
        }

        if (isError) {
          showAlert("error", `Support signup failed: ${errorMessage}`);
        } else {
          showAlert("success", "Support signup successful");
          new_history.push("/login");
        }
        return;
      }

      // ─────────────────────────────────────────────
      // Tenant signup
      // ─────────────────────────────────────────────
      const { tenant, email, password, full_name, phone, gender } = tenantData;

      const tenantFormData = new FormData();
      if (file) tenantFormData.append("file", file, file.name);
      tenantFormData.append("tenant", tenant);
      tenantFormData.append("type", "tenant_type");
      tenantFormData.append("password", password);
      tenantFormData.append("full_name", full_name);
      tenantFormData.append("email", email);
      tenantFormData.append("phone", phone);
      tenantFormData.append("gender", gender);
      tenantFormData.append("role", 196608);

      if (!isDevEnvironment && captchaToken) {
        tenantFormData.append("captcha_token", captchaToken);
      } else if (isDevEnvironment) {
        console.log("DEV Environment: Skipping CAPTCHA for tenant signup");
      }

      if (referedBy) tenantFormData.append("refered_by", referedBy);
      if (companyId) tenantFormData.append("company_id", companyId);

      // ─────────────────────────────────────────────
      // Build a single `meta_data` object that combines:
      //   - referral / UTM / metadata__* (existing behavior)
      //   - signup questionnaire answers (NEW)
      // Sent as one JSON string in `meta_data`.
      // ─────────────────────────────────────────────
      const metaData = {
        ...metadata,
        ...utmParams,
        signup_questionnaire: {
          setup_mode: signupPrefs.setup_mode || null,
          app_count_intent: signupPrefs.app_count_intent || null,
          captured_at: new Date().toISOString(),
        },
      };

      tenantFormData.append("meta_data", JSON.stringify(metaData));

      console.log("Sending meta_data to backend:", metaData);

      const response = await fetch(
        `https://auth2.${backend_api_base_url}/signup`,
        {
          method: "POST",
          headers: { Accept: "*/*" },
          body: tenantFormData,
        }
      );

      const inner_res = await response.json();

      if (inner_res?.statusCode && Number(inner_res.statusCode) !== 200) {
        const err_obj = JSON.parse(inner_res.body);
        showAlert("error", `Signup failed: ${err_obj.error}`);
      } else {
        showAlert("success", "Admin Signup Successful");
        new_history.push("/login");
      }
    } catch (err) {
      console.error("Error:", err);
      showAlert("error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePassVisibils = () => {
    setShowPassword(!showPassword);
  };

  const FieldIndicator = ({ type, onExampleClick }) => {
    const getIndicatorConfig = () => {
      switch (type) {
        case "fullName":
          return {
            text: "Can be updated later",
            className: signupStyle.updateLater,
          };
        case "tenant":
          return {
            text: "Can't be updated later",
            className: signupStyle.cannotUpdate,
            showExample: true,
          };
        case "phone":
          return {
            text: "Can be updated later",
            className: signupStyle.updateLater,
          };
        case "upload":
          return {
            text: "Can be updated later",
            className: signupStyle.updateLater,
          };
        default:
          return { text: "", className: "" };
      }
    };

    const config = getIndicatorConfig();

    return (
      <div className={`${signupStyle.fieldIndicator} ${config.className}`}>
        <FaInfoCircle className={signupStyle.indicatorIcon} />
        <span>{config.text}</span>
        {config.showExample && (
          <button
            type="button"
            className={signupStyle.exampleButton}
            onClick={onExampleClick}
          >
            View Example
          </button>
        )}
      </div>
    );
  };

  const hasTrackingParams =
    Object.keys(metadata).length > 0 || Object.keys(utmParams).length > 0;

  return (
    <div className={loginStyles.wrapper}>
      <Header />
      <div className={loginStyles.loginContainer}>
        <img src={loginbg} alt="bg" />
        <div className={loginStyles.loginContent}>
          <div className={loginStyles.login_left}>
            <h1>Sageion</h1>
            <p>3 In one Saas Based Chat Service Tool</p>
          </div>

          <div className={signupStyle.signup}>
            <div className={signupStyle.signupWraptab}>
              <h3>Create Your Account</h3>

              {hasTrackingParams && (
                <div className={signupStyle.trackingBadge}>
                  <FaInfoCircle /> Referral tracking active
                </div>
              )}

              {isDevEnvironment && (
                <div className={signupStyle.devBadge}>
                  ⚠️ DEV MODE - CAPTCHA DISABLED
                </div>
              )}

              <div className={signupStyle.tabsWrapper}>
                <button
                  type="button"
                  className={`${signupStyle.tabButton} ${
                    activeTab === "tenant_type" ? signupStyle.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("tenant_type")}
                >
                  Admin
                </button>
                <button
                  type="button"
                  className={`${signupStyle.tabButton} ${
                    activeTab === "support_type" ? signupStyle.activeTab : ""
                  }`}
                  onClick={() => setActiveTab("support_type")}
                >
                  Support
                </button>
              </div>
            </div>

            <form className={signupStyle.signupForm} onSubmit={handleSubmit}>
              {activeTab === "tenant_type" ? (
                <>
                  {/* ─────────────── Core fields ─────────────── */}
                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.labelWrapper}>
                      <label>Full Name</label>
                      <FieldIndicator type="fullName" />
                    </div>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type="text"
                        name="full_name"
                        placeholder="Enter your name"
                        value={tenantData.full_name}
                        onChange={handleTenantChange}
                        required
                      />
                      <FaRegCircleUser className={loginStyles.inputIcon} />
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <label>Email</label>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email id"
                        value={tenantData.email}
                        onChange={handleTenantChange}
                        required
                      />
                      <HiOutlineMail className={loginStyles.inputIcon} />
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <label>Password</label>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter your password"
                        value={tenantData.password}
                        onChange={handleTenantChange}
                        required
                      />
                      <button
                        type="button"
                        onClick={togglePassVisibils}
                        className={loginStyles["password-toggle-button"]}
                      >
                        {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                      </button>
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.labelWrapper}>
                      <label>Workspace ID</label>
                      <FieldIndicator
                        type="tenant"
                        onExampleClick={() => setShowExamplePopup(true)}
                      />
                    </div>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type="text"
                        name="tenant"
                        placeholder="Enter your tenant name"
                        value={tenantData.tenant}
                        onChange={handleTenantChange}
                        required
                      />
                      <FaRegCircleUser className={loginStyles.inputIcon} />
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.labelWrapper}>
                      <label>Phone</label>
                      <FieldIndicator type="phone" />
                    </div>
                    <PhoneInput
                      country={tenantCountry?.value || "in"}
                      value={tenantData.phone}
                      onChange={handleTenantPhoneChange}
                      inputProps={{ name: "phone", required: true }}
                      containerClass={signupStyle["phone-input-container"]}
                      inputClass={signupStyle["phone-input"]}
                    />
                  </div>

                  <div className={signupStyle.formGroup}>
                    <label>Gender</label>
                    <select
                      name="gender"
                      value={tenantData.gender}
                      onChange={handleTenantChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {/* ─────────────── Questionnaire ─────────────── */}
                  <div className={signupStyle.questionnaireSection}>
                    <div className={signupStyle.questionnaireHeader}>
                      <h4>Help us set up your dashboard the right way</h4>
                      <p>
                        Two quick questions. Your answers decide what we
                        surface first — and what stays out of your way. You
                        can change everything later.
                      </p>
                    </div>

                    {/* ── Q1: Solo or team ── */}
                    <div className={signupStyle.questionTile}>
                      <div className={signupStyle.questionLabelRow}>
                        <div>
                          <label className={signupStyle.questionLabel}>
                            Will you be working on this alone, or with a
                            team?
                          </label>
                          <p className={signupStyle.questionSubtext}>
                            We'll set up the right level of access for
                            whoever needs to respond to chats, configure
                            integrations, or manage the apps.
                          </p>
                        </div>
                        <button
                          type="button"
                          className={signupStyle.questionInfoBtn}
                          onClick={() => toggleInfo("setup_mode")}
                          aria-expanded={openInfoKey === "setup_mode"}
                        >
                          <FaInfoCircle />
                          <span>See what's included</span>
                        </button>
                      </div>

                      {openInfoKey === "setup_mode" && (
                        <div className={signupStyle.questionInfoPanel}>
                          <p>
                            Whether you're a two-person startup or a
                            200-person company, this question just tells us
                            who should be able to see and manage what.
                          </p>
                          <p>
                            Here's what it looks like in practice. Say you
                            run a small support team:
                          </p>
                          <ul>
                            <li>
                              <strong>You (Admin)</strong> — see every app,
                              every chat, every setting. Full control.
                            </li>
                            <li>
                              <strong>Your support agents</strong> — see
                              only the chats for the apps you've assigned
                              them. A clean, focused inbox — no clutter
                              from apps they don't own.
                            </li>
                            <li>
                              <strong>Your developer</strong> — sees only
                              the API and workflow sections. Configures
                              integrations without ever touching customer
                              conversations.
                            </li>
                          </ul>
                          <p>
                            Everyone logs in to the same portal, but each
                            person sees just what they need. You choose
                            who gets what — and you can change it anytime.
                          </p>
                          <p>
                            Starting solo? Totally fine. You can invite
                            your team later, whenever you're ready.
                          </p>
                        </div>
                      )}

                      <div className={signupStyle.choiceRow}>
                        {[
                          {
                            value: "solo",
                            label: "Just me",
                            hint: "I'll handle setup and chats myself",
                          },
                          {
                            value: "team",
                            label: "Me + my team",
                            hint:
                              "I'll invite support agents, developers, or managers",
                          },
                        ].map((opt) => (
                          <label
                            key={opt.value}
                            className={`${signupStyle.choiceCard} ${
                              signupPrefs.setup_mode === opt.value
                                ? signupStyle.choiceCardActive
                                : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="setup_mode"
                              value={opt.value}
                              checked={signupPrefs.setup_mode === opt.value}
                              onChange={(e) =>
                                handleSignupPrefsChange(
                                  "setup_mode",
                                  e.target.value
                                )
                              }
                            />
                            <span className={signupStyle.choiceTitle}>
                              {opt.label}
                            </span>
                            <span className={signupStyle.choiceHint}>
                              {opt.hint}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* ── Q2: One app or multiple ── */}
                    <div className={signupStyle.questionTile}>
                      <div className={signupStyle.questionLabelRow}>
                        <div>
                          <label className={signupStyle.questionLabel}>
                            How many chat apps do you plan to run?
                          </label>
                          <p className={signupStyle.questionSubtext}>
                            Some businesses run a single chat for everything.
                            Others run a separate one per business line or
                            audience — sales, support, internal — each on
                            its own site.
                          </p>
                        </div>
                        <button
                          type="button"
                          className={signupStyle.questionInfoBtn}
                          onClick={() => toggleInfo("app_count_intent")}
                          aria-expanded={openInfoKey === "app_count_intent"}
                        >
                          <FaInfoCircle />
                          <span>See what's included</span>
                        </button>
                      </div>

                      {openInfoKey === "app_count_intent" && (
                        <div className={signupStyle.questionInfoPanel}>
                          <p style={{ fontWeight: 600, color: "#1a1a1a" }}>
                            One account. Multiple businesses or teams. Zero
                            chaos.
                          </p>
                          <p>
                            Here's a simple example. Say you run an online
                            store and a service business under the same
                            company:
                          </p>
                          <ul>
                            <li>
                              <strong>App 1 — your online store</strong> —
                              the chat focuses on capturing sales leads,
                              answering product questions, and recommending
                              what to buy.
                            </li>
                            <li>
                              <strong>App 2 — your service business</strong>{" "}
                              — the chat focuses on supporting existing
                              customers, handling bookings, and escalating
                              to a human when needed.
                            </li>
                          </ul>
                          <p>
                            Both apps live under{" "}
                            <strong>one account</strong>, but they behave
                            completely differently — different bots,
                            different workflows, different look, and even
                            different websites or subdomains.
                          </p>
                          <p>
                            You invite the right people to work on the
                            right app. The sales team only sees the store
                            app. The support team only sees the service
                            app. You see both.
                          </p>
                          <p>
                            Setting up each app is a few clicks — no code,
                            no new infrastructure. And you can start with
                            just one app today. When you're ready for the
                            next one, you'll add it in minutes.
                          </p>
                        </div>
                      )}

                      <div className={signupStyle.choiceRow}>
                        {[
                          {
                            value: "one",
                            label: "One app for now",
                            hint: "Simple setup, easy to manage",
                          },
                          {
                            value: "multiple",
                            label: "Multiple apps",
                            hint: "One per team, audience, or domain",
                          },
                        ].map((opt) => (
                          <label
                            key={opt.value}
                            className={`${signupStyle.choiceCard} ${
                              signupPrefs.app_count_intent === opt.value
                                ? signupStyle.choiceCardActive
                                : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="app_count_intent"
                              value={opt.value}
                              checked={
                                signupPrefs.app_count_intent === opt.value
                              }
                              onChange={(e) =>
                                handleSignupPrefsChange(
                                  "app_count_intent",
                                  e.target.value
                                )
                              }
                            />
                            <span className={signupStyle.choiceTitle}>
                              {opt.label}
                            </span>
                            <span className={signupStyle.choiceHint}>
                              {opt.hint}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Common File Upload */}
                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.labelWrapper}>
                      <label>Upload Workspace Logo</label>
                      <FieldIndicator type="upload" />
                    </div>
                    <div className={signupStyle.attchmentWrap}>
                      <label htmlFor="file">
                        <TbCloudUpload className={signupStyle.fileIcon} />
                        Choose File
                      </label>
                      <input
                        type="file"
                        ref={imageInput}
                        id="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        tabIndex="-1"
                      />
                      {fileName && (
                        <div className={signupStyle.fileName}>{fileName}</div>
                      )}
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.checkboxWrapper}>
                      <input
                        type="checkbox"
                        id="termsTenant"
                        checked={tenantTerms}
                        onChange={handleTenantTermsChange}
                        required
                      />
                      <span>
                        I agree to Sageion{" "}
                        <a href="/terms_and_conditions_policy">
                          Terms of Service
                        </a>{" "}
                        and <a href="/privacy_policy">Privacy Policy.</a>
                      </span>
                    </div>
                  </div>
                </>
              ) : isSupportFlowWithoutToken ? (
                /* ─────────────── Invalid support link ─────────────── */
                <div className={signupStyle.invalidLinkPanel}>
                  <div className={signupStyle.invalidLinkIcon}>⚠️</div>
                  <h4>Invalid or expired signup link</h4>
                  <p>
                    This support signup link is missing its signup token.
                    Please use the original link from your invitation email,
                    or ask your admin to send you a fresh one.
                  </p>
                </div>
              ) : (
                <>
                  {/* ─────────────── Support Form ─────────────── */}
                  <div className={signupStyle.formGroup}>
                    <label>Full Name</label>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type="text"
                        name="full_name"
                        placeholder="Enter your name"
                        value={supportData.full_name}
                        onChange={handleSupportChange}
                        required
                      />
                      <FaRegCircleUser className={loginStyles.inputIcon} />
                    </div>
                  </div>

                  {/* Email — read-only, prefilled from URL. Not user-editable. */}
                  <div className={signupStyle.formGroup}>
                    <label>Email</label>
                    <div className={signupStyle.readOnlyField}>
                      {supportData.email || "—"}
                    </div>
                    <p className={signupStyle.questionSubtext}>
                      This is the email your invitation was sent to.
                    </p>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <label>Password</label>
                    <div className={loginStyles.inputWrapper}>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Set a password for your account"
                        value={supportData.password}
                        onChange={handleSupportChange}
                        required
                      />
                      <button
                        type="button"
                        onClick={togglePassVisibils}
                        className={loginStyles["password-toggle-button"]}
                      >
                        {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                      </button>
                    </div>
                  </div>

                  {/* NOTE: Signup token field intentionally hidden.
                      The token is supplied via the URL and flows to the
                      backend automatically on submit. */}

                  <div className={signupStyle.formGroup}>
                    <label>Upload Support Image</label>
                    <div className={signupStyle.attchmentWrap}>
                      <label htmlFor="file">
                        <TbCloudUpload className={signupStyle.fileIcon} />
                        Choose File
                      </label>
                      <input
                        type="file"
                        ref={imageInput}
                        id="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        tabIndex="-1"
                      />
                      {fileName && (
                        <div className={signupStyle.fileName}>{fileName}</div>
                      )}
                    </div>
                  </div>

                  <div className={signupStyle.formGroup}>
                    <div className={signupStyle.checkboxWrapper}>
                      <input
                        type="checkbox"
                        id="termsSupport"
                        checked={supportTerms}
                        onChange={handleSupportTermsChange}
                        required
                      />
                      <span>
                        I agree to Sageion{" "}
                        <a href="/terms_and_conditions_policy">
                          Terms of Service
                        </a>{" "}
                        and <a href="/privacy_policy">Privacy Policy.</a>
                      </span>
                    </div>
                  </div>
                </>
              )}

              {/* CAPTCHA + Submit only shown when form is valid */}
              {!isSupportFlowWithoutToken && (
                <>
                  {!isDevEnvironment && (
                    <>
                      <ReCAPTCHA
                        sitekey={
                          process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
                        }
                        onChange={(token) => setCaptchaToken(token)}
                      />
                      {!captchaToken && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          Please verify reCAPTCHA
                        </p>
                      )}
                    </>
                  )}

                  {isDevEnvironment && (
                    <div
                      style={{
                        backgroundColor: "#f0f0f0",
                        padding: "10px",
                        borderRadius: "4px",
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "10px",
                      }}
                    >
                      ℹ️ CAPTCHA disabled in development environment
                    </div>
                  )}

                  <LoadingButton
                    type="submit"
                    isLoading={isLoading}
                    className={loginStyles.button}
                  >
                    Signup
                  </LoadingButton>

                  <div className={loginStyles.signupLink}>
                    <span>Already have an account?</span>
                    <Link to="/login">Login</Link>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      </div>

      {showExamplePopup && (
        <div className={signupStyle.examplePopupOverlay}>
          <div className={signupStyle.examplePopup}>
            <div className={signupStyle.popupHeader}>
              <h3>Workspace ID Example</h3>
              <button
                className={signupStyle.closeButton}
                onClick={() => setShowExamplePopup(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className={signupStyle.popupContent}>
              <img
                src={tenantname_example}
                alt="Workspace ID example"
                className={signupStyle.exampleImage}
              />
              <p>
                This is an example of how your Workspace ID should look.
                Choose a unique and recognizable name for your organization.
              </p>
            </div>
          </div>
        </div>
      )}

      {alert.show && (
        <AlertPopup
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ ...alert, show: false })}
        />
      )}
    </div>
  );
};